import service from '@/services/currency/CurrencyService'

export const currencyModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    currency: [],
    currencyList: [],
    loadingItems: false,
    opering: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_CURRENCY(state, payload) {
      state.currency = []
      state.currency.push(payload)
    },
    SET_CURRENCY_LIST(state, payload) {
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
      state.currencyList = payload.data ?? payload
    },
    SET_LOADING_ITEMS(state) {
      state.loadingItems = !state.loadingItems
    },
    SET_OPERING(state) {
      state.opering = !state.opering
    },
  },
  actions: {
    async getCurrency({ commit }, query) {
      try {
        commit('SET_LOADING_ITEMS')
        let response = await service.getCurrency(query)
        if (response && response.data) {
          commit('SET_CURRENCY', response.data[0])
          response.data.shift()
          commit('SET_CURRENCY_LIST', response)
        }
      } finally {
        commit('SET_LOADING_ITEMS')
      }
    },
    async insertCurrency({ dispatch }, payload) {
      let response = await service.insert(payload)

      dispatch('getCurrency', { ultimo: '' })

      return response.status
    },
    async deleteCurrency({ commit, dispatch }, payload) {
      try {
        commit('SET_OPERING')

        let response = await service.deleteCurrency(payload.DATA)

        await dispatch('getCurrency', { ultimo: '' })

        return response.status
      } finally {
        commit('SET_OPERING')
      }
    },
  },
}
